// UN agente visto con el mismo contexto que la lista (Santi, su subida y la hora del reloj de aparcar): lo que leen el
// chat (cabecera, línea de encima de la caja, ⋮), la ficha y el menú de la mesa. Antes cada uno decidía «te necesita» o
// «se puede aparcar» a su manera y un agente terminado decía «Te necesita» en su chat mientras la lista lo ponía en «Han
// terminado» (05-11, auditoría final flujo.md #3). La fila de la lista no lo usa: recibe lo mismo calculado por useEquipo.
import { useMemo } from 'react';
import type { ContratadoDTO } from '../compartido/vocabulario';
import type { Despliegue } from '../despliegues/api';
import { useSubidas } from '../despliegues/store';
import { useSantiPorAgente } from '../pelotas/porAgente';
import { estadoDelAgente, type EstadoAgente } from './acciones';
import type { SantiDelAgente } from './situacion';
import { useRelojAparcar } from './useEquipo';

export interface Agente extends EstadoAgente<Despliegue> {
  santi: SantiDelAgente | undefined;
  subida: Despliegue | null;
  ahora: number;
}

export function useAgente(c: ContratadoDTO): Agente {
  const santiPorAgente = useSantiPorAgente();
  const { porAgente } = useSubidas();
  const uno = useMemo(() => [c], [c]);
  // Su propio temporizador, con la regla de la lista (proximoCambioDe): cambia justo cuando cambia su fila.
  const ahora = useRelojAparcar(uno, santiPorAgente, porAgente);
  const santi = santiPorAgente.get(c.agentId);
  const subida = porAgente.get(c.agentId) ?? null;
  return useMemo(() => ({ ...estadoDelAgente(c, santi, subida, ahora), santi, subida, ahora }), [c, santi, subida, ahora]);
}
